import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CookieConsentService {
  constructor() {}

  cookieAccepted = new BehaviorSubject<boolean>(false);
}
